/********************************************************************************************************************************
 * import.meta.url only works from within ESM modules. This means, that it will fail in the Jest tests as currently configured.
 * For the tests, babel-plugin-transform-import-meta is used to convert the statements into code compatible with CommonJS.
 * See jest-preprocess.js - since *.coffee files run through the jest-coffee-preprocessor.js first, it will still fail when it is
 * used from within Coffeescript files. This is why the creation of the workers is extracted into this *.js helper file.
 ********************************************************************************************************************************/

export const createCompressionWorker = () => {
  return new Worker(new URL("../upload/compression.worker", import.meta.url))
}

export const createEncryptionWorker = () => {
  return new Worker(new URL("../upload/encryption.worker", import.meta.url))
}
